import { MenuIconProps } from "@type-defs/general/TMenuIconProps";

const ConsignmentIcon = (props: MenuIconProps) => {
  const { isRouted } = props;
  const color = isRouted ? "#ffffff" : "#6b7280";

  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_1952_145691)">
        <path
          d="M12.5 7.17792C12.0908 7.17792 11.758 6.84517 11.758 6.43599H11.0161C11.0161 7.12562 11.491 7.70136 12.129 7.86718V8.66179H12.871V7.91986H13.9839V6.43599C13.9839 5.61763 13.3183 4.95212 12.5 4.95212C12.0908 4.95212 11.758 4.61936 11.758 4.21018V3.46825H12.5C12.9092 3.46825 13.2419 3.801 13.2419 4.21018H13.9839C13.9839 3.52055 13.509 2.94481 12.871 2.77899V1.98438H12.129V2.72631H11.0161V4.21018C11.0161 5.02854 11.6816 5.69405 12.5 5.69405C12.9092 5.69405 13.2419 6.02681 13.2419 6.43599V7.17792H12.5Z"
          fill={color}
          stroke={color}
          stroke-width="0.2"
        />
        <path
          d="M21.6132 5.69355H17.3037C17.3133 5.57076 17.3226 5.44797 17.3226 5.32258C17.3226 2.66348 15.1591 0.5 12.5 0.5C9.8409 0.5 7.67742 2.66348 7.67742 5.32258C7.67742 5.44797 7.68669 5.57076 7.69634 5.69355H3.38681L1 9.67144V9.77419C1 10.8073 1.60802 11.6988 2.48387 12.1169V22.0161H6.19355V22.3871C6.19355 23.0007 6.69287 23.5 7.30645 23.5H17.6935C18.3071 23.5 18.8065 23.0007 18.8065 22.3871V22.0161H22.5161V12.1169C23.392 11.6991 24 10.8073 24 9.77419V9.67144L21.6132 5.69355ZM22.9739 9.40323H19.4286L18.2415 6.43548H21.1929L22.9739 9.40323ZM14.3174 10.1452C14.1449 10.9906 13.3959 11.629 12.5 11.629C11.6041 11.629 10.8551 10.9906 10.6826 10.1452H14.3174ZM17.4424 6.43548L18.6295 9.40323H15.0586C16.1132 8.73956 16.8919 7.68156 17.1879 6.43548H17.4424ZM18.7642 10.1452C18.5913 10.9899 17.8468 11.629 16.9516 11.629C16.0561 11.629 15.3067 10.9906 15.1342 10.1452H18.7642ZM12.5 1.24194C14.7499 1.24194 16.5806 3.07266 16.5806 5.32258C16.5806 7.5725 14.7499 9.40323 12.5 9.40323C10.2501 9.40323 8.41935 7.5725 8.41935 5.32258C8.41935 3.07266 10.2501 1.24194 12.5 1.24194ZM9.94181 9.40323H6.37087L7.55797 6.43548H7.81245C8.10811 7.68156 8.88715 8.73956 9.94181 9.40323ZM9.86576 10.1452C9.69326 10.9906 8.94427 11.629 8.04839 11.629C7.15324 11.629 6.40871 10.9899 6.23584 10.1452H9.86576ZM3.80674 6.43548H6.75816L5.57106 9.40323H2.0261L3.80674 6.43548ZM1.78571 10.1452H5.41415C5.24165 10.9906 4.49266 11.629 3.59677 11.629C2.70163 11.629 1.95895 10.9899 1.78571 10.1452ZM18.0645 22.3871C18.0645 22.5919 17.898 22.7581 17.6935 22.7581H7.30645C7.10205 22.7581 6.93548 22.5919 6.93548 22.3871V14.9677C6.93548 14.763 7.10205 14.5968 7.30645 14.5968H9.90323V17.5645H15.0968V14.5968H17.6935C17.898 14.5968 18.0645 14.763 18.0645 14.9677V22.3871ZM12.871 15.3387V16.8226H12.129V15.3387H11.3871V16.8226H10.6452V14.5968H14.3548V16.8226H13.6129V15.3387H12.871ZM21.7742 21.2742H18.8065V14.9677C18.8065 14.3542 18.3071 13.8548 17.6935 13.8548H7.30645C6.69287 13.8548 6.19355 14.3542 6.19355 14.9677V21.2742H3.22581V12.3413C3.34748 12.3587 3.47065 12.371 3.59677 12.371C4.542 12.371 5.36815 11.8616 5.82258 11.1049C6.27702 11.8616 7.10316 12.371 8.04839 12.371C8.99361 12.371 9.81976 11.8616 10.2742 11.1049C10.7286 11.8616 11.5548 12.371 12.5 12.371C13.4452 12.371 14.2714 11.8616 14.7258 11.1049C15.1802 11.8616 16.0064 12.371 16.9516 12.371C17.8968 12.371 18.723 11.8616 19.1774 11.1049C19.6319 11.8616 20.458 12.371 21.4032 12.371C21.5294 12.371 21.6525 12.3587 21.7742 12.3413V21.2742ZM21.4032 11.629C20.5077 11.629 19.7584 10.9906 19.5859 10.1452H23.2143C23.041 10.9899 22.2984 11.629 21.4032 11.629Z"
          fill={color}
          stroke={color}
          stroke-width="0.2"
        />
        <path
          d="M15.8386 21.2734H15.0967V22.0154H15.8386V21.2734Z"
          fill={color}
          stroke={color}
          stroke-width="0.2"
        />
        <path
          d="M14.3547 21.2734H13.6128V22.0154H14.3547V21.2734Z"
          fill={color}
          stroke={color}
          stroke-width="0.2"
        />
        <path
          d="M17.3225 21.2734H16.5806V22.0154H17.3225V21.2734Z"
          fill={color}
          stroke={color}
          stroke-width="0.2"
        />
        <path
          d="M17.3225 19.791H13.6128V20.533H17.3225V19.791Z"
          fill={color}
          stroke={color}
          stroke-width="0.2"
        />
        <path
          d="M4.70971 14.5977H3.96777V15.3396H4.70971V14.5977Z"
          fill={color}
          stroke={color}
          stroke-width="0.2"
        />
        <path
          d="M4.70971 13.1133H3.96777V13.8552H4.70971V13.1133Z"
          fill={color}
          stroke={color}
          stroke-width="0.2"
        />
        <path
          d="M4.70971 16.0801H3.96777V16.822H4.70971V16.0801Z"
          fill={color}
          stroke={color}
          stroke-width="0.2"
        />
        <path
          d="M21.0325 16.8223H20.2905V17.5642H21.0325V16.8223Z"
          fill={color}
          stroke={color}
          stroke-width="0.2"
        />
        <path
          d="M21.0325 18.3066H20.2905V19.0486H21.0325V18.3066Z"
          fill={color}
          stroke={color}
          stroke-width="0.2"
        />
        <path
          d="M21.0325 19.791H20.2905V20.533H21.0325V19.791Z"
          fill={color}
          stroke={color}
          stroke-width="0.2"
        />
      </g>
      <defs>
        <clipPath id="clip0_1952_145691">
          <rect width="24" height="24" fill={color} />
        </clipPath>
      </defs>
    </svg>
  );
};

export default ConsignmentIcon;
